import React from 'react';
import { getButtonClasses } from './Button.utils';
import { LoadingSpinner } from '../Spinner';
import type { ButtonProps, ButtonRef } from './Button.types';

export const Button = React.forwardRef<ButtonRef, ButtonProps>(
  (
    {
      variant = 'primary',
      size = 'md',
      fullWidth = false,
      loading = false,
      leftIcon,
      rightIcon,
      children,
      className,
      disabled,
      ...props
    },
    ref
  ) => {
    const isDisabled = disabled || loading;
    const buttonClasses = getButtonClasses(
      variant,
      size,
      fullWidth,
      loading,
      className
    );
    
    const inlineStyles =
      variant === 'secondary' || variant === 'linkButton'
        ? {
          transition:
            'background-position 0.4s ease-in-out, color 0.4s ease-in-out',
        }
        : {};
    return (
      <button
        ref={ref}
        className={`${buttonClasses} `}
        disabled={isDisabled}
        {...props}
        style={inlineStyles}
      >
        {loading && (
          <LoadingSpinner size={size === 'sm' ? 'sm' : 'md'} className='mr-2' />
        )}
        {leftIcon && !loading && (
          <span className='mr-2 flex-shrink-0'>{leftIcon}</span>
        )}
        {children}
        {rightIcon && <span className='ml-2 flex-shrink-0'>{rightIcon}</span>}
      </button>
    );
  }
);

Button.displayName = 'Button';
